module.exports = __webpack_public_path__ + "static/frida-a09d00e88dbcb4e52b98a0609af925e0.jpg";